import React, { useState, useEffect } from 'react';
import './Headers.css';

const Header = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100);

      const sections = ['home', 'about','car-rental', 'tour-packages', 'gallery', 'contact'];
      let currentSection = 'home';

      sections.forEach(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            currentSection = section;
          }
        }
      });

      setActiveSection(currentSection);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 140; // Combined height of top-bar (70px) + nav (70px) on mobile
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`header ${isSticky ? 'sticky' : ''}`}>
      <nav className="navigation">
      <div className="container-fluid topbar">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="contact-info">
                <a href="tel:+918072938793">
                  <i className="fas fa-phone"></i>+91 8072938793
                </a>
                <a href="mailto:gvtravelsmadurai@gmail.com">
                  <i className="fas fa-envelope"></i> gvtravelsmadurai@gmail.com
                </a>
              </div>
            </div>
            <div className="col-md-6">
              <div className="social-links">
                <a 
                  href="https://www.instagram.com/gv_travelsmadurai?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div className="nav-container">
          <a 
            href="#home" 
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('home');
            }} 
            className="logo"
          >
            <img src="../images/BG-logo.png" alt="GV Travels Logo" />
          </a>

          <div className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <ul className="nav-links">
              <li>
                <a
                  href="#home"
                  className={activeSection === 'home' ? 'active' : ''}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('home');
                  }}
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="#about"
                  className={activeSection === 'about' ? 'active' : ''}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('about');
                  }}
                >
                  About
                </a>
              </li>
              <li>
              <a
                href="#car-rental"
                className={activeSection === 'car-rental' ? 'active' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('car-rental');
                }}
              >
                Tariffs
              </a>
            </li>
              <li>
                <a
                  href="#tour-packages"
                  className={activeSection === 'tour-packages' ? 'active' : ''}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('tour-packages');
                  }}
                >
                  Tour Packages
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className={activeSection === 'contact' ? 'active' : ''}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('contact');
                  }}
                >
                  Contact
                </a>
              </li>
              {/* <li>
                <a
                  href="#gallery"
                  className={activeSection === 'gallery' ? 'active' : ''}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('gallery');
                  }}
                >
                  Gallery
                </a>
              </li> */}
            </ul>

            <a
              href="#contact"
              className="book-now-btn"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('contact');
              }}
            >
              BOOK NOW
            </a>
          </div>

          <button 
            className="mobile-menu-btn" 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Header;